/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Aurélien Bulliard",
  title: "Salut c'téquipe, ça joue ou bien ?",
  subTitle: emoji(
    "Moi c'est Aurel, j'aime bidouiller des choses, surtout quand ça fait bip bip, ou tchou tchou."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aurel-bul",
  linkedin: "https://www.linkedin.com/in/aur%C3%A9lien-bulliard-29b939281/",
  gmail: "aurelien.bulliard@gmail.com",
  twitter: "https://x.com/Mineaurel",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Je fais quoi dans la vie ?",
  subTitle: "Bonne question, je me la pose parfois aussi. Voici plusieurs noms qui te diront probablement pas grand chose...",
  skills: [
    emoji(
      "🐧 J'aime bien bidouiller tout ce qui touche à mon manchot préféré (Tux)."
    ),
    emoji("💣 Si ça se passe sur une carte électronique qui pourrait être confondue avec une bombe, ça me plaît."),
    emoji("🚂 Et si en plus ça touche au tchous tchous, alors c'est étonnant que je sois pas déjà passé par là !"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Linux",
      fontAwesomeClassname: "devicon-linux-plain colored"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "devicon-docker-plain colored"
    },
    {
      skillName: "Go",
      fontAwesomeClassname: "devicon-go-plain colored"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "devicon-java-plain colored"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "devicon-python-plain colored"
    },
    {
      skillName: "Ansible",
      fontAwesomeClassname: "devicon-ansible-plain colored"
    },
    {
      skillName: "Terraform",
      fontAwesomeClassname: "devicon-terraform-plain colored"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "devicon-html5-plain colored"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "devicon-css3-plain colored"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "devicon-javascript-plain colored"
    },
    {
      skillName: "C",
      fontAwesomeClassname: "devicon-c-plain colored"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "devicon-cplusplus-plain colored"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Haute école d'ingénierie et d'architecture de Fribourg",
      logo: require("./assets/images/heia.png"),
      subHeader: "Bachelor of Science en Informatique et Systèmes de communication, option Réseaux et Systèmes",
      duration: "Septembre 2023 - Aoùt 2026",
      desc: "Travail de Bachelor: Nexus - Clusterisation d'une plateforme VDI open-source",
    },
    {
      schoolName: "École des métiers de Fribourg",
      logo: require("./assets/images/emf.jpg"),
      subHeader: "Certifical Fédéral de Capacité (CFC) d'informaticien d'entreprise",
      duration: "Septembre 2019 - Juillet 2023",
      desc: "Maturité professionnelle intégrée, stage de 4ème chez Tebicom SA",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Réseaux", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Systèmes / Infrastructures",
      progressPercentage: "75%"
    },
    {
      Stack: "Programmation",
      progressPercentage: "50%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Technicien Workplace",
      company: "Tebicom SA",
      companylogo: require("./assets/images/tebi.jpg"),
      date: "Juillet 2023 – Aujourd'hui",
      desc: "Contrat en alternance",
      descBullets: [
        "Installation de postes de travail",
        "Déploiement de postes via MDT et Autopilot (modern workplace)",
        "Dépannage système et réseau",
        "Helpdesk niveau 1 et 2",
        "Support utilisateur sur site"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projets majeurs",
  subtitle: "Projets sur lesquels j'ai travaillé un bon petit bout de temps",
  projects: [
    {
      projectName: "Nexus VDI",
      projectDesc: "Travail de Bachelor : clusterisation d'une plateforme VDI open-source",
      footerLink: [
        {
          name: "Voir le repo",
          url: "https://gitedu.hesge.ch/flg_projects/nexus_vdi"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle:
    "Rien de fou, mais ça claque sur un CV",

  achievementsCards: [
    {
      title: "CCNA: Enterprise Networking, Security, and Automation",
      image: require("./assets/images/ccna-2.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/04ee2352-016b-4c9f-b3a5-5692ae175a05/public_url"
        }
      ]
    },
    {
      title: "CCNA: Switching, Routing, and Wireless Essentials",
      image: require("./assets/images/ccna-3.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/0a0cee28-dd68-497c-8b95-69a18bb84f21/public_url"
        }
      ]
    },

    {
      title: "CCNA: Introduction to Networks",
      image: require("./assets/images/ccna-1.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/901cec2f-76da-4db2-949e-d0700108b6c0/public_url"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "CV",
  subtitle: "Si vraiment....",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Dis-moi bonjour !",
  subtitle:
    "Pas tous en même temps !",
  number: "non",
  email_address: "aurelien.bulliard@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
